module.exports = __webpack_public_path__ + "android.svg?81906cb3882668d32fb9378e33777d29";


//////////////////
// WEBPACK FOOTER
// ./src/components/Campaign/AppsBudgets/Images/android.svg
// module id = 112
// module chunks = 20